import { render, staticRenderFns } from "./Tutoriais.vue?vue&type=template&id=77bc8122&scoped=true&"
import script from "./Tutoriais.vue?vue&type=script&lang=js&"
export * from "./Tutoriais.vue?vue&type=script&lang=js&"
import style0 from "./Tutoriais.vue?vue&type=style&index=0&id=77bc8122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc8122",
  null
  
)

export default component.exports